import { CmsComponentsBase } from '@/cmsComponents/base';
import Headline from '@uikit/components/Headline/Headline';
import ImageGallery from '@uikit/components/ImageGallery/ImageGallery';
import PressImageWrapper from '@uikit/components/Press/PressImage/PressImageWrapper';
import PressArticleRichText from '@uikit/composites/PressArticleRichText/PressArticleRichText';

export const cmsComponents = {
  ...CmsComponentsBase,
  'communal-article-image-gallery': ImageGallery,
  'communal-article-headline': Headline,
  'communal-article-rich-text': PressArticleRichText,
  'communal-article-image': PressImageWrapper,
};
